export const MEMBER_DETECTION = 'MEMBER_DETECTION';
export const ACTIVITY_LOCATION = 'ACTIVITY_LOCATION';
export const USER_TYPE = 'USER_TYPE';



// WEBPACK FOOTER //
// ./src/app/browser/redux/appActionKeys.js